import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function useBodyPathClasses() {
  const location = useLocation();

  useEffect(() => {
    const pathSegments = location.pathname
      .split('/')
      .filter(Boolean); // remove empty segments

    // Optional prefix to avoid conflicts with other body classes
    const classPrefix = 'path-';

    // Add classes to body
    pathSegments.forEach((segment,index) => {
      document.body.classList.add(`${classPrefix}${segment}`);
      document.body.classList.add(`${classPrefix}${index}`);
    });

    // Cleanup: remove classes on unmount or path change
    return () => {
      pathSegments.forEach((segment,index) => {
        document.body.classList.remove(`${classPrefix}${segment}`);
        document.body.classList.remove(`${classPrefix}${index}`);
      });
    };
  }, [location.pathname]);
}

export default useBodyPathClasses;
